import IconAsMaskImage from '../IconAsMaskImage'

const SuccessIcon = ({ pureSvg, className, color, ...rest }) => {
  const svg = (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
      <g opacity="0.3">
        <rect x="5.50033" y="5.49935" width="25" height="25" rx="12.5" stroke="#079455" strokeWidth="1.66667" />
      </g>
      <g opacity="0.1">
        <rect
          x="1.33333"
          y="1.33333"
          width="33.3333"
          height="33.3333"
          rx="16.6667"
          stroke="#079455"
          strokeWidth="1.66667"
          {...rest}
        />
      </g>
      <g clipPath="url(#clip0_7574_5066)">
        <path
          d="M14.2503 17.9993L16.7503 20.4993L21.7503 15.4993M26.3337 17.9993C26.3337 22.6017 22.6027 26.3327 18.0003 26.3327C13.398 26.3327 9.66699 22.6017 9.66699 17.9993C9.66699 13.397 13.398 9.66602 18.0003 9.66602C22.6027 9.66602 26.3337 13.397 26.3337 17.9993Z"
          stroke="#079455"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7574_5066">
          <rect width="20" height="20" fill="white" transform="translate(8 8)" />
        </clipPath>
      </defs>
    </svg>
  )

  if (pureSvg) return svg

  return <IconAsMaskImage {...{ svg, className, color }} />
}

export default SuccessIcon
